import { Node, Plugin } from 'tiptap';
import { nodeInputRule } from 'tiptap-commands';

const VIDEO_INPUT_REGEX = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/;
// const VIMEO_REGEX = /vimeo.*\/(\d+)/i;
const VIMEO_STRING = 'https://player.vimeo.com/video/';
const YOUTUBE_STRING = 'https://www.youtube.com/embed/';

export default class Video extends Node {
  get name() {
    return 'video';
  }

  get schema() {
    return {
      attrs: {
        src: {},
      },
      group: 'block',
      draggable: false,
      parseDOM: [
        {
          tag: 'iframe',
          getAttrs: (dom) => ({
            src: `${_getVideoString(dom.getAttribute('src'))}`,
            width: '100%',
            height: '480',
            frameborder: '0',
            allow: 'autoplay; fullscreen',
            allowfullscreen: true,
            a: dom,
          }),
        },
      ],
      toDOM: (node) => [
        'iframe',
        {
          src: `${_getVideoString(node.attrs.src)}`,
          width: '100%',
          height: '480',
          frameborder: '0',
          allow: 'autoplay; fullscreen',
          allowfullscreen: true,
          controls: true,
          a: node,
        },
      ],
    };
  }

  commands({ type }) {
    return (attrs) => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }

  inputRules({ type }) {
    return [
      nodeInputRule(VIDEO_INPUT_REGEX, type, (match) => {
        const [, src] = match;
        return {
          src,
        };
      }),
    ];
  }

  get plugins() {
    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            drop(view, event) {
              const hasFiles =
                event.dataTransfer &&
                event.dataTransfer.files &&
                event.dataTransfer.files.length;

              if (!hasFiles) {
                return;
              }

              const videos = Array.from(
                event.dataTransfer.files,
              ).filter((file) => /video/i.test(file.type));

              if (videos.length === 0) {
                return;
              }

              event.preventDefault();

              const { schema } = view.state;
              const coordinates = view.posAtCoords({
                left: event.clientX,
                top: event.clientY,
              });

              videos.forEach((video) => {
                const reader = new FileReader();

                reader.onload = (readerEvent) => {
                  const node = schema.nodes.video.create({
                    src: readerEvent.target.result,
                  });
                  const transaction = view.state.tr.insert(
                    coordinates.pos,
                    node,
                  );
                  view.dispatch(transaction);
                };
                reader.readAsDataURL(video);
              });
            },
          },
        },
      }),
    ];
  }
}

function _getVideoString(videoUrl) {
  
  if(videoUrl.includes('vimeo')){
    if (videoUrl.includes(VIMEO_STRING))
      return videoUrl;
    return videoUrl.replace('https://vimeo.com/', VIMEO_STRING);
  }else{
    if (videoUrl.includes(YOUTUBE_STRING))
      return videoUrl;
    return videoUrl.replace('https://www.youtube.com/watch?v=', YOUTUBE_STRING);
  }
}
